<template>
    <div>
<!--        The department named <strong>{{ $_.get(activity, "payload.name") }}</strong> was removed by-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>.-->
        <span v-html="$t('notification.departmentRemoved', { user: $_.get(activity, 'actorUser.name'), department:$_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "DepartmenRemoved",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
